import { QuestionOrderBy } from '@data/sdk/match';

export const SORT_OPTIONS = [
  { value: QuestionOrderBy.Distance, label: 'relevance' },
  { value: QuestionOrderBy.UpdatedAt, label: 'updated_at' },
  { value: QuestionOrderBy.QuestionType, label: 'question_type' },
  { value: QuestionOrderBy.IsActive, label: 'is_active' },
  { value: QuestionOrderBy.AnsweredCount, label: 'answered_count' },
  { value: QuestionOrderBy.SkippedCount, label: 'skipped_count' },
  { value: QuestionOrderBy.TrialCount, label: 'trial_count' },
  { value: 'icdTrialCount', label: 'icd_trial_count' },
];
